import React from 'react';
import Header from '../Header/Header';
import { WicktockModel } from './Wicktockmodel';

const Wicktok = () => {
    const wicktockModel = WicktockModel();
    return (
        <>
            <Header />

            <div className="container">
                <div className="row">

                    {
                        wicktockModel.lstWicktok.length > 0 ?

                            (wicktockModel.lstWicktok && wicktockModel.lstWicktok.map((d: any, index: number) => (
                                //     <video
                                //     #videoElement
                                //     playsinline
                                //     muted
                                //     [src]="VideoAPIPath + d.VideoURL"
                                //     class="w-100 media"
                                //     [autoplay]="i == 0 ? true:false"
                                //     style="border-radius: 14px; padding: 5px; min-height: 200px; max-height: 300px;"
                                //     [id]="'video_' + i"
                                //   ></video>
                                <div className="col-md-12 p-5" key={index}>
                                    <video src={wicktockModel.VideoAPIPath + d.VideoURL} autoPlay={index == 0 ? true : false} controls
                                        style={{ 'minHeight': '70vh', 'maxHeight': '80vh','width':'100%' }}
                                    ></video>
                                    <span className='text-start' style={{'float': 'left','textAlign': 'left'}}>
                                        <i className={d.Liked == 1 ? 'bi bi-heart-fill mx-2 text-danger':'bi bi-heart mx-2 text-light'} onClick={(e)=>wicktockModel.like(d)}></i>
                                        <i className='bi bi-share mx-2 text-light'></i>
                                        {/* <i className='bi bi-heart-fill'></i> */}
                                    </span>
                                </div>
                            ))) :

                            <div className="col-md-6 mx-auto">
                                <img src="../assets/img/icons_svg/no-data.svg" alt="" />
                            </div>
                    }

                </div>
            </div>
        </>
    )
}

export default Wicktok;